import { Component, Input } from '@angular/core';
import { MembershipSpecializationService } from '../services/membership.specialization.service';

import { MembershipSpecialization } from '../models/membership.specialization.model';
import { NotificationService } from '../services/notification.service';
import { LookupService } from '../services/lookup.service';

@Component({
  selector: 'app-membership-specialization-list',
  templateUrl: './membership-specialization-list.component.html'
})
export class MembershipSpecializationListComponent {
  @Input() id: number;

  constructor(public lookupService: LookupService, public service: MembershipSpecializationService, private notificationService: NotificationService) { }

  ngOnInit() {
    this.service.membershipTypeID = this.id;
    this.onSearch();
  }

  model = new MembershipSpecialization();
  modelSearch = new MembershipSpecialization();
  modelPush = new MembershipSpecialization();

  onNew() {
    this.model = new MembershipSpecialization();
    $("#PanelSearch, #PanelPush").hide();
    $('#PanelForm').slideToggle();
  }

  onPush() {
    this.modelPush = new MembershipSpecialization();
    $("#PanelSearch, #PanelForm").hide();
    $('#PanelPush').slideToggle();
  }

  onEdit(model) {

    $('#PanelForm').slideToggle();

    this.model = Object.assign({}, model);
  }

  onStatus(values: any, membershipSpecializationID): void {

    if (!confirm('Are you sure?'))
      return;

    this.service.model = new MembershipSpecialization();
    this.service.model.membershipSpecializationID = membershipSpecializationID;

    if (values.currentTarget.checked)
      this.service.updateStatus(1).subscribe(
        res => {
          this.notificationService.notifySuccess();
        },
        err => { console.log(err); }
      );
    else
      this.service.updateStatus(0).subscribe(
        res => {
          this.notificationService.notifySuccess();
        },
        err => { console.log(err); }
      );
  }

  onArchive(id) {
    if (!confirm('Are you sure?')) {
      return;
    }

    this.service.archive(id).subscribe(
      res => {
        this.notificationService.notifySuccess();
      },
      err => { console.log(err); }
    );

  }

  onSearch() {
    this.service.list = null;
    this.service.currentPage = 1;
    this.service.modelSearch = this.modelSearch;
    this.service.search();
  }

  onSubmitPush() {

    this.service.model = this.modelPush;

    this.service.push().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.onSearch();
      },
      err => { console.log(err); }
    );
  }
}

